export * from './phoneme-categories.component';